module.exports = __webpack_public_path__ + "img/68400.15c36ac9.jpg";